<template>
  <v-select chips :items="models" label="Models" variant="solo" color="deep-purple" v-model="modelSelect" hide-details
    multiple clearable/>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const models = store.getters.models.sort()

const modelSelect = computed({
  get () {
    return store.getters.selectedModels
  },
  set (value) {
    store.commit('selectedModels', value)
  }
})
</script>
